import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the AsistentesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AsistentesProvider {
  public isLoggedIn: boolean = false
 

  private api: string = "";

  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello ASSISTE Provider');
  }

  // Elimina un asistente
  public delete(nclave): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "asistentes",
      "clave": nclave,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un nuevo asistente
  public insert(congreso,asistente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    asistente.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "asistentes",
      "parametros": asistente,
      "clavecongreso":congreso.clave 
    };
  
    console.log(parametros);
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }
  public insertexcel(congreso,asistentes,opciones): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    //asistente.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "parametros": asistentes,
      "opciones": opciones,
      "clavecongreso":congreso.clave 
    };
  
    console.log(parametros);
    return this.http.post(this.api+"asistentes/insert_excel.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso,asistente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "asistentes",
      "clave": asistente.clave,
      "parametros": asistente,
      "clavecongreso":congreso.clave 
    };
    console.log(parametros);
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        console.log(response);
        var respuesta = response.json();
      
         return respuesta[0];
      }
    ).catch(this.handleError);
  }
  public updatepolitica(congreso,asistente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
var para= {politica: 1};
    let parametros ={
      "token":this.global.token,
      "tabla": "asistentes",
      "clave": asistente,
      "parametros": para,
      "clavecongreso":congreso.clave 
    };
    console.log(parametros);
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        console.log(response);
        var respuesta = response.json();
      
         return respuesta[0];
      }
    ).catch(this.handleError);
  }


  // Devuelve todos los poenentes de un congreso
  public allsinetiqueta(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tabla":"asistentes",
      "campofiltro":"clavecongreso",
      "valorfiltro": clavecongreso,
      "campoorden": "nombre"
    };
  
    return this.http.post(this.api+"apigen/list.php", parametros, options).map(
      (response) => {
      
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api + "asistentes/listaasistentes.php", parametros, options).map(
      (response) => {
              console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  public asistentereunion(clavereunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "token": this.global.token,
      "clavereunion": clavereunion,
      "claveasistente":this.global.ficha_asistente.clave
    };
   
    return this.http.post(this.api + "asistentes/reunion_asistente.php", parametros, options).map(
      (response) => {
              console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  public chats_asistente(clavecongreso,claveasistente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "claveasistente": claveasistente,
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api + "asistentes/listachats.php", parametros, options).map(
      (response) => {
              console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  irchat(asistente_destino){
    //this.navCtrl.push('page-chats', {congresoactivo:this.congresoactivo, asistente_destino: asistente_destino,asistente_origen:this.global.ficha_asistente,tipo:1});

  }
  
  public datos_asistente(claveasistente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "claveasistente": claveasistente
    };
 
    return this.http.post(this.api + "asistentes/datos_asistente.php", parametros, options).map(
      (response) => {
              
        return response.json();

      }
    ).catch(this.handleError);
  }
  
  public ordena(congreso,asistentes): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "asistentes",
      "parametros": asistentes
    };
   
    return this.http.post(this.api+"apigen/orden.php", parametros, options).map(
      (response) => {
      
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  public login(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email: '"' + user.email + '"',
      password: '"' + user.password + '"',
      clavecongreso:this.global.congresoglobal.clave,
      dispositivo: '"' + this.global.guid+ '"'
    };
   console.log(parametros);
    return this.http.post(this.api+'ws_login_asistente.php', parametros, options).map(
      (response) => {
      
        console.log(response);
        return response.json();
      }
    ).catch(this.handleError);
  }
  public logout(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email: '"' + user.mail + '"',
      password: '"' + user.password + '"',
      clavecongreso:this.global.congresoglobal.clave,
      dispositivo: '"' + this.global.guid+ '"'
    };
   console.log(parametros);
    return this.http.post(this.api+'ws_logout_asistente.php', parametros, options).map(
      (response) => {
      
        
        return response.json();
      }
    ).catch(this.handleError);
  }
  public password(user): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email:  user.email ,
      clavecongreso:this.global.congresoglobal.clave
    };
    console.log(parametros);
    return this.http.post(this.api+'ws_password_asistente.php', parametros, options).map(
      (response) => {
        
      
        return response.json();
      }
    ).catch(this.handleError);
  }
  public password_lista(email,tipo): Observable<any>  {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      email: '"' + email + '"',
      tipo: tipo,
      clavecongreso:this.global.congresoglobal.clave
    };
    
    return this.http.post(this.api+'asistentes/envia_password.php', parametros, options).map(
      (response) => {
        
      
        return response.json();
      }
    ).catch(this.handleError);
  }

  public asistente_favoritos(claveasistente,operacion): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "dispositivo": this.global.guid,
      "claveasistente": claveasistente,
      "token":this.global.token
    };
    
   
    if(operacion==1){
      return this.http.post(this.api+"asistentes/insert_favorito.php", parametros, options).map(
        (response) => {
          
          return response.json();
          
        }
      ).catch(this.handleError);
    }else{
      return this.http.post(this.api+"asistentes/delete_favorito.php", parametros, options).map(
        (response) => {
          
          return response.json();
          
        }
      ).catch(this.handleError);
    }
   
  }

  public delete_reunion(nclave): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "reunionesasistentes",
      "clave": nclave,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }
  public delete_reunion_asistente(reunion,asistente): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "asistente": asistente,
      "reunion": reunion,
    };

    return this.http.post(this.api+"reunion/delete_asistente.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }
  // Inserta un nuevo asistente
  public insert_reunion(reunion): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
   
    let parametros ={
      "token":this.global.token,
      "tabla": "reunionesasistentes",
      "parametros": reunion,
      "clavecongreso":this.global.congresoglobal.clave 
    };
  
    console.log(parametros);
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }
  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
   
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/asistentes/asistentes.ts